var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9584 2.92825C9.76207 2.5867 9.23795 2.5867 9.04163 2.92825L2.31353 14.6113C2.14498 14.9064 2.34431 15.3279 2.77137 15.3279H16.2287C16.6557 15.3279 16.8554 14.9068 16.6868 14.6117L9.9584 2.92825ZM11.2586 2.1802C10.4853 0.835878 8.5141 0.836052 7.74116 2.18072L1.01283 13.8641L1.01199 13.8656C0.237857 15.2169 1.25688 16.8279 2.77137 16.8279H16.2287C17.7431 16.8279 18.7622 15.2169 17.988 13.8656L11.2586 2.1802Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2499 7.06C10.2499 6.64578 9.91415 6.31 9.49994 6.31C9.08573 6.31 8.74994 6.64578 8.74994 7.06V10.1374C8.74994 10.5516 9.08573 10.8874 9.49994 10.8874C9.91415 10.8874 10.2499 10.5516 10.2499 10.1374V7.06ZM10.5 13.3852C10.5 13.9375 10.0523 14.3852 9.50003 14.3852C8.94775 14.3852 8.50003 13.9375 8.50003 13.3852C8.50003 12.8329 8.94775 12.3852 9.50003 12.3852C10.0523 12.3852 10.5 12.8329 10.5 13.3852Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/iconWarning.64ede6f12cf71b87d994fa87fb784840.svg";
export { ForwardRef as ReactComponent };